/**
 * The discreet "no important errors" ✓ of a learner bubble (D10). Whether it
 * shows is decided by `selectCleanSentenceTicks`; this only renders it: a small
 * lime check in the bubble's annotation row, after any correction chips. No
 * text, no sound, no tap — only a short fade in.
 */
import { IconCheck } from '../icons.js';
import type { UiLocale } from '../coachCatalog.js';
import './cleanSentenceTick.css';

/** Learner-facing copy (es first, speak's UI language; en ready for a locale). */
export const CLEAN_SENTENCE_TICK_COPY: Record<UiLocale, { label: string }> = {
  es: { label: 'Sin errores importantes' },
  en: { label: 'No important errors' },
};

interface CleanSentenceTickProps {
  locale?: UiLocale;
}

export function CleanSentenceTick({ locale = 'es' }: CleanSentenceTickProps) {
  const { label } = CLEAN_SENTENCE_TICK_COPY[locale];
  return (
    <span className="clean-tick" role="img" aria-label={label} title={label}>
      <IconCheck size={11} />
    </span>
  );
}
